/* eslint-disable quotes */
export default {
  AWAY_TIME: 'g',
  COMMON__MINUTES: 'p',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: 'Sửa chữa',
    BUTTON__DELETE: 'Xóa',
    MESSAGE_STATUS__DELETE: 'Xóa',
    MESSAGE_MENU__DELETE: 'Xóa',
    BUTTON__SAVE: 'Lưu',
    BUTTON__CLOSE: 'Đóng',
    BUTTON__CANCEL: 'Hủy',
    CHANNEL_SETTING__PROFILE__EDIT: 'Chỉnh sửa',
    MESSAGE_INPUT__PLACE_HOLDER: 'Vui lòng nhập',
    MODAL__CHANNEL_INFORMATION__UPLOAD: 'Tải lên',
    EDIT_PROFILE__IMAGE_UPLOAD: 'Tải lên',
    CHANNEL_LIST__TITLE: 'Kênh',
    MESSAGE_MENU__COPY: 'Sao chép',
    CHANNEL_SETTING__HEADER__TITLE: 'Thông tin kênh',
    MODAL__USER_LIST__TITLE: 'Thành viên',
    CHANNEL_SETTING__MEMBERS__TITLE: 'Thành viên',
    NO_MEMBERS: '(Không có thành viên nào)',
    NO_NAME: '(Vô danh)',
    TOOLTIP__UNKOWN_USER: '(Vô danh)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'Rời khỏi kênh',
    BUTTON__INVITE: 'Mời',
    MODAL__INVITE_MEMBER__SELECTED: 'Đã chọn',
    MODAL__CREATE_CHANNEL__SELECTED: 'Đã chọn',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'Tên kênh',
    MODAL__INVITE_MEMBER__TITLE: 'Thêm thành viên',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: 'Nhập vào',
    BUTTON__CREATE: 'Tạo mới',
    MODAL__CREATE_CHANNEL__TITLE: 'Kênh mới',
    TRYING_TO_CONNECT: 'Đang cố gắng kết nối….',
    USER_PROFILE__MESSAGE: 'Tin nhắn',
    USER_PROFILE__USER_ID: 'ID người dùng',
    EDIT_PROFILE__USERID_LABEL: 'ID người dùng',
    EDIT_PROFILE__TITLE: 'Hồ sơ của tôi',
    EDIT_PROFILE__IMAGE_LABEL: 'Hình ảnh của tôi',
    EDIT_PROFILE__NICKNAME_LABEL: 'Biệt danh',
    EDIT_PROFILE__THEME_LABEL: 'Chủ đề tối màu',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'Không thể trò chuyện trong kênh này.',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'Đã đọc đến đây',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'Kích hoạt',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: 'Tất cả thành viên',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: 'Mời người dùng',
    MODAL__DELETE_MESSAGE__TITLE: 'Bạn có muốn xóa tin nhắn này không?',
    MODAL__CHANNEL_INFORMATION__TITLE: 'Chỉnh sửa thông tin của kênh',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'Hình ảnh của kênh',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: 'Vui lòng nhập tên vào',
    TYPING_INDICATOR__IS_TYPING: 'Đang nhập….',
    TYPING_INDICATOR__ARE_TYPING: 'Đang nhập….',
    TYPING_INDICATOR__MULTIPLE_TYPING: 'Đang nhập….',
    TYPING_INDICATOR__AND: 'và',
    MESSAGE_STATUS__SENDING_FAILED: 'Không thể gửi tin nhắn.',
    MESSAGE_STATUS__TRY_AGAIN: 'Vui lòng thử lại lần nữa.',
    MESSAGE_STATUS__OR: 'hoặc',
    PLACE_HOLDER__WRONG: 'Đã xảy ra lỗi.',
    PLACE_HOLDER__RETRY_TO_CONNECT: 'Thử lại',
    NO_TITLE: 'Không có tiêu đề',
    TOOLTIP__AND_YOU: ', và tôi',
    TOOLTIP__YOU: 'Tôi',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(Tin nhắn không rõ)',
    UNKNOWN__CANNOT_READ_MESSAGE: 'Không thể đọc được tin nhắn này.',
    MESSAGE_EDITED: '(Đã chỉnh sửa)',
    PLACE_HOLDER__NO_CHANNEL: 'Hãy bắt đầu một cuộc hội thoại mới.',
    MESSAGE_MENU__REPLY: 'Trả lời',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: 'Tôi',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: 'Viết phản hồi',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: 'Xác nhận',
  SETTINGS__NONE: 'Không có',
  SEARCH__NO_RESULT: 'Không có kết quả tìm kiếm.',
  LOGIN__PASSWORD: 'Mật khẩu',
  SEARCH__USER_PLACEHOLDER: 'Tìm kiếm bằng tên/ mã số/ số điện thoại',
  BASIC__: {
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: 'Quyền xem lịch sử chấm công của tôi',
    ERROR: 'Xảy ra lỗi.<br /> Vui lòng thử lại sau.',
    MSG__: { INPUT: 'Vui lòng nhập cụm từ tìm kiếm của bạn.' },
    PWD_ALL_VALIDATION: 'Mật khẩu phải bao gồm chữ cái viết hoa / thường, số và các ký tự đặc biệt của %1$@~%2$@ chữ.',
    RETRY: 'Thử lại',
    PASSWORD_RULE: 'Chứa 8 đến 20 ký tự gồm tiếng Anh, chữ in hoa, chữ số, ký tự đặc biệt',
  },
  SEARCH__NO_USER_INFO: 'Không có thông tin người dùng.',
  LOGIN__EMAIL_OR_HP: 'Email hoặc số điện thoại',
  BASIC__SEARCH: 'Tìm kiếm',
  ELECTRON: {
    MENU_DELETE: 'Xóa',
    MENU_VIEW: 'Xem',
    MENU_SIGN_OUT: 'Thoát',
    MENU_SETTINGS: 'Cài đặt',
    MENU_CLOSE: 'Đóng',
    MENU_EDIT: 'Chỉnh sửa',
    MENU_SELECT_ALL: 'Chọn tất cả',
    MENU_COPY: 'Sao chép',
    MENU_FILE: 'Tập tin',
    MENU_ABOUT: 'Thông tin về {0}',
    MENU_UPDATE: 'Kiểm tra cập nhật',
    MENU_HIDE: 'Ẩn {0}',
    MENU_HIDE_OTHERS: 'Ẩn những ứng dụng khác',
    MENU_SHOW_ALL: 'Hiển thị tất cả',
    MENU_QUIT: 'Kết thúc {0}',
    MENU_NEW_CHANNEL: 'Kênh mới',
    MENU_UNDO: 'Hoàn tác',
    MENU_REDO: 'Làm lại',
    MENU_CUT: 'Cắt',
    MENU_PASTE: 'Dán',
    MENU_PASTE_AND_MATCH_STYLE: 'Kiểu dán',
    MENU_RELOAD: 'Tải lại',
    MENU_FORCE_RELOAD: 'Bắt buộc tải lại',
    MENU_FULL_SCREEN: 'Chuyển sang toàn màn hình',
    MENU_RESET_ZOOM: 'Kích thước thực tế',
    MENU_ZOOM_IN: 'Phóng to',
    MENU_ZOOM_OUT: 'Thu nhỏ',
    MENU_WINDOW: 'Cửa sổ',
    MENU_MINIMIZE: 'Tối thiểu hóa',
    MENU_ZOOM: 'Tối đa hóa',
    MENU_HELP: 'Trợ giúp',
    MESSAGE_UP_TO_DATE: 'Bạn đang sử dụng phiên bản mới nhất.',
    UPDATE_AVAILABLE: 'Có thể cập nhật',
    MESSAGE_UPDATE_AVAILABLE: 'Có thể cập nhật phiên bản mới nhất.',
    UP_TO_DATE: 'Phiên bản mới nhất',
  },
  LOGIN__INSERT_EMAIL_HP: 'Xin hãy nhập email hoặc số điện thoại.',
  LOGIN__PASSWORD_GUIDE_SUBTITLE:
    'Trong trường hợp bạn quên mật khẩu, hãy thử cài đặt lại mật khẩu ở trang đăng nhập của ứng dụng điện thoại.',
  LOGIN__INSERT_PASSWORD: 'Xin hãy nhập mật khẩu.',
  LOGIN__PASSWORD_INFORMATION: 'Không thể nhớ mật khẩu của bạn?',
  BEFORE: 'Vốn có',
  ALERT__NO_ONE_SELECTED: 'Không có nhân viên được chọn.',
  LOGOUT: 'Thoát',
  LOGIN: 'Đăng nhập',
  COMMON__SECONDS: 'Giây',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: 'Nếu chỉnh sửa bị ngưng, nội dung đã sửa đổi sẽ không được lưu.',
      ARE_YOU_SURE_WANT_TO_STOP: 'Bạn có muốn ngừng chỉnh sửa lịch trình không?',
    },
  },
  TEMPLATE__: {
    GUIDE__: { NO_TEMPLATE_REGISTERED: 'Không có giao diện được đăng ký' },
  },
  SETTINGS__CHANGE_LANGUAGE: 'Cài đặt ngôn ngữ',
  SEARCH__MEMBER_PLACEHOLDER: 'Tên/ Mã số nhân viên/ Số điện thoại',
  MSG__: {
    BASIC__: { NO_SEARCH_RESULT: 'Không có kết quả.' },
    ERROR__: {
      CREATE_CHANNEL: 'Không thể tạo kênh.',
      UPDATE_CHANNEL_INFO: 'Không thể cập nhật thông tin kênh.',
      LEAVE_CHANNEL: 'Không thể rời khỏi kênh.',
    },
    FILE__: { MAXIMGSIZE: 'Kích thước tập tin đã vượt quá 25MB.' },
    ALLOW_BROWSER_ALARM:
      'Để xem tin nhắn thông báo, bạn cần phải cho phép thông báo trong mục cài đặt trình duyệt của mình.',
    LABEL__: { SEARCH_MESSAGE: 'Tìm kiếm tin nhắn' },
    GUIDE__: {
      SEARCH_MESSAGE: 'Tìm kiếm nội dung tin nhắn mà bạn muốn tìm trong mục {0}.',
    },
  },
  BASIC__UNKNOWN: 'Không rõ',
  LOGIN__SERVER_ALERT: 'Không thể kết nối với máy chủ.',
  INVITE__MEMBER_SELECTION: 'Chọn thành viên',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: 'Hiển thị tên vừa thay đổi cho tất cả thành viên của kênh.',
  NOTICE: 'Thông báo',
  INVITE__CREATE: 'Tạo mới',
  CHANNEL__LEAVE_THIS_CHANNEL: 'Bạn muốn rời khỏi kênh?',
  LOGIN__PASSWORD_FAIL_COUNT: 'Mật khẩu không chính xác {0} lần.',
  LOGIN__FAIL_ALERT: 'Bạn đã nhập sai mật khẩu 5 lần liên tiếp, bạn sẽ bị khóa trong vòng 5 phút.',
  LOGIN__LOCK_STATE_ALERT: 'Bạn đã nhập sai mật khẩu liên tiếp, bạn sẽ bị khóa trong vòng 5 phút.',
  LOGIN__RETRY_ALERT: 'Vui lòng thử lại sau {0}.',
  LOGIN__PASSWORD_GUIDE_TITLE:
    'Mật khẩu ShopIChat của bạn trùng với mật khẩu của ứng dụng trên thiết bị di động của bạn.',
  SETTINGS__ALL_MESSAGES: 'Cài đặt thông báo cho tất cả các tin nhắn mới',
  SETTINGS__ALARM_SOUND: 'Âm thanh',
  SETTINGS__SOUND_ALARM: 'Âm báo',
  SETTINGS__LISTEN_ALARM_SOUND: 'Nghe',
  ALERT__MAX_INVITE_MEMBER: 'Số thành viên có thể tham gia kênh tối đa là 20,000 người.',
  LOGIN__DEACTIVATED_ALERT: 'Người quản lý không kích hoạt tính năng trò chuyện nên bạn không thể đăng nhập được.',
  LOGIN__SERVER_ALERT_CONTENTS:
    'Bạn không thể đăng nhập do mạng không ổn định. Vui lòng kiểm tra kết nối Internet và thử lại lần nữa.',
  LOGIN__LOGOUT_ALERT: 'Bạn đã đăng xuất.',
  CHANNEL__EDIT_CHANNEL_NAME: 'Thay đổi tên của kênh',
  SETTINGS__THEME: 'Chủ đề',
  SETTINGS__LANGUAGE: 'Ngôn ngữ',
  SETTINGS__LIGHT_THEME: 'Sáng',
  SETTINGS__DARK_THEME: 'Tối',
  SEARCH__CHANNEL_PLACEHOLDER: 'Tên nhân viên',
  CHANNEL__CONTACT: 'Trò chuyện 1:1',
  BASIC: { LABEL: { MAXIMAGECNT: 'Bạn có thể tải tối đa {0} hình ảnh.' } },
  LOGIN__LOGIN_FAILED: 'ID hoặc mật khẩu không đúng.',
  FORGOT_PW: 'Bạn quên mật khẩu?',
  BASIC__MAX_FORMAT_INPUT: 'Bạn có thể nhập tối đa %@ ký tự.',
  SERVICE__COMING_SOON: 'Sắp ra mắt',
  LOGIN__GUIDE: 'Bạn có thể đăng nhập bằng tài khoản đã sử dụng trên ứng dụng.',
  MOBILE__: {
    ACCESS_PC: 'Vui lòng truy cập Dashboard từ PC!',
    ACCESS_DESC_01: 'Dashboard đang được tối ưu hóa ở môi trường PC.',
    ACCESS_DESC_02: 'Vui lòng truy cập qua PC để sử dụng một cách thuận tiện.',
    ACCESS_PC_ONLY: 'Vui lòng truy cập qua PC!',
    GUIDE: 'Bạn có thể sử dụng tính năng trò chuyện trên ứng dụng PC hoặc di động.',
  },
  CHANNEL__NO_CHAT_HISTORY: 'Không có lịch sử trò chuyện',
};
